<nz-spin [nzSpinning]="refreshing">
  <nz-button-group class="multi-report">
    <button type="button" nz-button class="preview-btn" (click)="previewFormat(reportFormats[0])" [disabled]="!docCode || disabled"
      [nzLoading]="loading">
      Preview
    </button>
    <button type="button" nz-button nz-dropdown [nzDropdownMenu]="extraReports" nzPlacement="bottomRight" [disabled]="!docCode || disabled">
      <span nz-icon nzType="down">
      </span>
    </button>
  </nz-button-group>
  <nz-dropdown-menu #extraReports="nzDropdownMenu">
    <ul nz-menu>
      @for (report of reportFormats; track $index) {
      @if (this.einvoiceControl === 0 || this.einvoiceControl === 3) {
      @if (!report.isEInvFormat) {
      <li nz-menu-item (click)="previewFormat(report)">
        <span *ngIf="$index !== 0">
          {{ report.displayName }}
        </span>
        <strong *ngIf="$index === 0">
          {{ report.displayName }}
        </strong>
        <nz-tag *ngIf="report.isEInvFormat" [nzColor]="'warning'">eInv</nz-tag>
      </li>
      }
      } @else {
      <li nz-menu-item (click)="previewFormat(report)">
        <span *ngIf="$index !== 0">
          {{ report.displayName }}
        </span>
        <strong *ngIf="$index === 0">
          {{ report.displayName }}
        </strong>
        <nz-tag *ngIf="report.isEInvFormat" [nzColor]="'warning'">eInv</nz-tag>
      </li>
      }
      }
      <li nz-menu-divider></li>
      <li nz-menu-item>
        <button type="button" nz-button nzType="primary" (click)="loadReportFormats()">
          Reload
        </button>
      </li>
    </ul>
  </nz-dropdown-menu>
</nz-spin>
